export enum PAYMENTS_ACTION_TYPES {
  FETCH_PAYMENTS = 'FETCH_PAYMENTS',
  AUTHORIZE_PAYMENT = 'AUTHORIZE_PAYMENT',
}
